var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentPostIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1828_24839)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04073 -0.0234375L16.4899 -0.0234375C17.6252 -0.0234375 18.5541 0.905438 18.5541 2.04073V16.4899C18.5541 17.6252 17.6252 18.5541 16.4899 18.5541H2.04073C0.905438 18.5541 -0.0234375 17.6252 -0.0234375 16.4899L-0.0234375 2.04073C-0.0234375 0.905438 0.905438 -0.0234375 2.04073 -0.0234375ZM5.76862 3.6836C4.61709 3.6836 3.6836 4.61709 3.6836 5.76862C3.6836 6.92014 4.6171 7.85364 5.76862 7.85364H12.7187C13.8702 7.85364 14.8037 6.92014 14.8037 5.76862C14.8037 4.61709 13.8702 3.6836 12.7187 3.6836L5.76862 3.6836ZM3.6836 11.0966C3.6836 10.5848 4.09849 10.1699 4.61027 10.1699H13.877C14.3888 10.1699 14.8037 10.5848 14.8037 11.0966C14.8037 11.6084 14.3888 12.0233 13.877 12.0233H4.61028C4.09849 12.0233 3.6836 11.6084 3.6836 11.0966ZM4.61027 12.9502C4.09849 12.9502 3.6836 13.3651 3.6836 13.8769C3.6836 14.3886 4.09849 14.8035 4.61028 14.8035H13.877C14.3888 14.8035 14.8037 14.3886 14.8037 13.8769C14.8037 13.3651 14.3888 12.9502 13.877 12.9502H4.61027Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1828_24839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5775,
    height: 18.5775
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPostIcon);
export default __webpack_public_path__ + "static/media/ContentPostIcon.d126ff3d2dce05e878460a5c785a1b5a.svg";
export { ForwardRef as ReactComponent };